<template>
    <modal-cadu close :width="642" v-model="valueData">
        <div slot="all" class="py-6 px-10">
            <div slot="header" class="primary1--text headline font-weight-bold">
                Competência Pendente
            </div>
            <div slot="body" class="linha">
                <v-row no-gutters>
                    <v-col class="py-2">
                        <div>
                            <div class="fontColor--text subtitle-2">
                                A competência {{dateConverter}} da {{objPendente.subMenu}} não foi preenchida.<br>
                                <span class="font-weight-bold">
                                    Por gentileza, retorne e atualize a quantidade de {{objPendente.subMenu}}
                                    da competência desatualizada
                                </span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div slot="footer" class="pr-1">
                <v-row align="center" justify="end" no-gutters>
                    <v-col cols="auto">
                        <button-cadu @click="$emit('input', false)" text="OK"/>
                    </v-col>
                </v-row>
            </div>
        </div>
    </modal-cadu>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    objPendente: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      valueData: this.value
    }
  },
  computed: {
    dateConverter () {
      return this.objPendente.mesPendente.split('-').reverse().join('/')
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      this.justificativa = ''
      this.$emit('input', this.valueData)
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
    border-top: 1px solid #DEE2E6
    width: 98%
    margin: 5px 0
</style>
